<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="{{modalData.icon}}"></div>
    </div>
    <h2>{{evaluateLanguageString(modalData.title)}}</h2>
    <div>
      <p class="content-text">{{evaluateLanguageString(modalData.description)}}</p>
    </div>
    <div class="ya-dialog-action">
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <div class="ya-button-container">
            <button mat-flat-button (click)="acceptBtn()">
              <span>{{evaluateLanguageString(modalData.buttonTextAccept)}}</span>
            </button>
          </div>
          <div *ngIf="modalData.buttonTextDeny" class="ya-button-container">
            <button mat-stroked-button (click)="denyBtn()">
              <span>{{evaluateLanguageString(modalData.buttonTextDeny)}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>